import { actionTypes } from './constants';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { searchAttendeesStatsByEventApi } from 'src/redesign/features/AttendeeStats/api';
import { AttendeeStatsPayload } from 'src/redesign/features/AttendeeStats/types';

export const searchAttendeesStatsByEvent = createAsyncThunk(
  actionTypes.FETCH_ATTENDEE_STATS,
  async ({ eventId, offset = 0, limit = 10, criteria }: AttendeeStatsPayload) => {
    return await searchAttendeesStatsByEventApi({
      eventId,
      offset,
      limit,
      criteria,
    });
  },
);
